export default "__VITE_ASSET__Dsyzw36t__"